import { Alignment, Navbar } from "@blueprintjs/core";
import { Link } from "react-router";

import { useCurrentUser } from "@/components/helpers/custom-hooks/use-current-user";
import { Box, Flex } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";
import { ImpersonatingMessage } from "@/components/nav/ImpersonatingMessage";
import { LOGO_HEIGHT } from "@/components/pages_logged_in/workspace/nav/SideNav/WorkspaceMenuLogo";
import { Logo } from "@/components/pieces/menu/Logo";
import {
  NAV_Z_INDEX,
  STANDARD_APP_MAX_WIDTH,
  STANDARD_NAV_HEIGHT,
} from "@/css/constants";

interface HeaderProps {
  linkToDash?: boolean;
  backButton?: React.ReactNode;
}

export function Header({ linkToDash = false, backButton }: HeaderProps) {
  const navHeight = STANDARD_NAV_HEIGHT;
  const currentUser = useCurrentUser();

  const image = currentUser?.currentWorkspace?.logo;

  const logoHeight =
    LOGO_HEIGHT > navHeight - 12 ? navHeight - 12 : LOGO_HEIGHT;

  const logo = image ? (
    <Box height={logoHeight} m="12px">
      <img
        src={image}
        style={{
          objectFit: "contain",
          maxWidth: 220,
          width: "100%",
          height: "100%",
        }}
      />
    </Box>
  ) : (
    <Logo height={30} width={150} />
  );

  return (
    <Navbar
      fixedToTop={true}
      style={{ zIndex: NAV_Z_INDEX, height: navHeight }}
    >
      <Box
        style={{
          maxWidth: STANDARD_APP_MAX_WIDTH,
          height: navHeight,
          margin: "0 auto",
        }}
      >
        <Navbar.Group align={Alignment.LEFT} style={{ height: navHeight }}>
          {backButton}
          <Flex>{linkToDash ? <Link to="/dashboard">{logo}</Link> : logo}</Flex>
        </Navbar.Group>
        <Navbar.Group align={Alignment.CENTER} style={{ height: navHeight }}>
          <Media greaterThan="md">
            <ImpersonatingMessage />
          </Media>
        </Navbar.Group>
      </Box>
    </Navbar>
  );
}
